<template>
  <section class="section">
    <div class="stage">
      <div class="stage__image"></div>
      <div class="container-fluid container-lg">
        <div class="stage__text">
          <h1>Wilkommen zum offiziellen Portal von Mixdorf</h1>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Stage"
}
</script>

<style scoped>

</style>